import React from 'react';

const NotFound = () => {
    return (
        <div>
            <h1 style={{color:'white'}}>Sorry!! Page Not Found...</h1>
        </div>
    );
};

export default NotFound;